import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {ApiResponse} from '../auth/auth.models';
import {buildApiUrl} from '../shared/api/api-url';
import {JournalPage, JournalPageDto, mapJournalEvent} from './events.models';
import {EventJournalCountDto} from './event-journal-count-dto';

@Injectable({providedIn: 'root'})
export class EventsService {
  private readonly http = inject(HttpClient);
  count(): Observable<EventJournalCountDto> {
    return this.http.get<ApiResponse<EventJournalCountDto>>(buildApiUrl('/v1/events/count')).pipe(map(response => {
      const count = response.data?.count;
      if (typeof count !== 'number' || !Number.isSafeInteger(count) || count < 0) throw new Error('Invalid event count.');
      return {count};
    }));
  }
  page(cursor: string | null = null, limit = 20): Observable<JournalPage> {
    const params: Record<string, string> = {limit: String(limit)};
    if (cursor) params['cursor'] = cursor;
    return this.http.get<ApiResponse<JournalPageDto>>(buildApiUrl('/v1/events'), {params}).pipe(map(response => {
      if (!response.data) throw new Error('Missing event page.');
      return {items: response.data.items.map(mapJournalEvent), nextCursor: response.data.nextCursor};
    }));
  }
}
